import axios from 'axios';

const configuredBackendUrl = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
const isLocalBrowser = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);
const apiBaseUrl = isLocalBrowser ? '/api' : (configuredBackendUrl ? `${configuredBackendUrl}/api` : '/api');

const api = axios.create({
  baseURL: apiBaseUrl,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  // Bearer token as fallback for development (cross-origin where cookies won't work)
  const token = localStorage.getItem('yh_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('yh_token');
      localStorage.removeItem('yh_user');
      localStorage.removeItem('yh_tenant');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
